function Stepper({ currentStep, completedStep }) {
    const steps = ["Login", "Address", "Order"]
    return (
        <ol className="flex stepper items-center w-full text-sm font-medium text-center sm:text-base">
            {steps.map((step, index) => (
                <li key={step + index} className={`flex md:w-full items-center ${currentStep === index + 1 ? "text-indigo-600" : completedStep.includes(index + 1) ? "text-green-600" : "text-gray-500"} after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-4 xl:after:mx-4`}>
                    <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 ">
                        {completedStep.includes(index + 1) ? <svg className={`w-3.5 h-3.5 sm:w-4 sm:h-4 mr-2 sm:mr-2.5`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20"> <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" /> </svg>
                            : <span className="mr-2">{index + 1}</span>
                        }   <span className="inline-flex sm:ml-2 uppercase">{step}</span>
                    </span>
                </li>
            ))}
            <li className={`flex items-center ${currentStep === 4 ? "text-indigo-600" : "text-gray-500"} sm:text-base`}>
                <span className="flex items-center sm:after:hidden after:mx-2 after:text-gray-200">
                    <span className="mr-2 up">4</span>
                    <span className="uppercase">Payment</span>
                </span>
            </li>
        </ol>
    );
}

export default Stepper;


